/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { FormSection } from '@fitinsur/components'

import { DeclarationTemplateSection } from '../index';

function RenderSection({
  disableAll,
  formikProps,
  formikRef,
  idProduct,
  idOperation,
  idOperationParent,
  globalQuestionnaire,
}) {

  return (  
    <FormSection
      sectionName="DECLARATION_TEMPLATE"
      formikRef={formikRef}
      disableAll={disableAll}
      values={formikProps.values}
      errors={formikProps.errors}
      setFieldValue={formikProps.setFieldValue}
      setFieldError={formikProps.setFieldError}
      questionnaire={globalQuestionnaire}
      idOperation={idOperation}
      idOperationParent={idOperationParent}
      idProduct={idProduct}
      onQuestionChange={(
        question,
        value,
        questionnaireUpdated,
        setQuestionnaireUpdated,
        setFieldValue
      ) =>
        DeclarationTemplateSection.events.handleQuestionChange({
          question,
          value,
          questionnaireUpdated,
          setQuestionnaireUpdated,
          setFieldValue,
          globalQuestionnaire,
        })
      }
    />
  )
}

const components = {
  RenderSection
}

export { components }